import * as API from '../api/OrdersApi';
import { StripeCharge } from '../types/Stripe';
import {
  OrderBookingOption,
  OrderHistoryRecord,
  OrderPaymentDetailsObject,
  OrderRefundPayload,
  OrderRequestRefundPayload,
} from '../types/Order';
import { OrderUpdateOption } from '../types/OrderUpdateOption';

export function getAllOrders(sort, filterData, from, getAll) {
  return API.getAllOrders(sort, filterData, from, getAll);
}

export function getOrdersByActivity(activityId, sort) {
  return API.getOrdersByActivity(activityId, sort);
}

export async function getOrderPaymentDetails(orderId: string) {
  const response = await API.getOrderPaymentDetails(orderId);

  return response.filter(
    item =>
      item.object !== OrderPaymentDetailsObject.refund ||
      item.status !== 'canceled'
  );
}

export function getOrdersByParty(partyId, sort) {
  return API.getOrdersByParty(partyId, sort);
}

export function getOrderUpdateOptions(
  activityId: string,
  bookingOptions: OrderBookingOption[],
  orderId: string,
  startDateTime: string,
  endDateTime: string
): Promise<OrderUpdateOption[]> {
  return API.getOrderUpdateOptions(
    activityId,
    bookingOptions,
    orderId,
    startDateTime,
    endDateTime
  );
}

export function getOrdersByDates(dateFrom, dateTo) {
  return API.getOrdersByDates(dateFrom, dateTo);
}

export function getOrderById(orderId) {
  return API.getOrderById(orderId);
}

export function getOrder(
  activityId,
  partyId,
  partyName,
  tz,
  eventId,
  bookingOptions,
  startDateTime,
  endDateTime,
  bookingOwner
) {
  return API.getOrder(
    activityId,
    partyId,
    partyName,
    tz,
    eventId,
    bookingOptions,
    startDateTime,
    endDateTime,
    bookingOwner
  );
}

export function applyPromoCode(draftActivity, promoCode) {
  return API.applyPromoCode(draftActivity, promoCode);
}

export function chargeOrder(orderId, cardId) {
  return API.chargeOrder(orderId, cardId);
}

export function requestPartialRefund(
  orderId: string,
  payload: OrderRequestRefundPayload
) {
  return API.requestPartialRefund(orderId, payload);
}
export function refundOrder(orderId: string, payload: OrderRefundPayload) {
  return API.refundOrder(orderId, payload);
}

export function getOrderCharges(orderId): Promise<StripeCharge[]> {
  return API.getOrderCharges(orderId);
}

export function fulfillOrder(orderId) {
  return API.fulfillOrder(orderId);
}

export function cancelOrderFulfillment(orderId, reason, reasonNote) {
  return API.cancelOrderFulfillment(orderId, reason, reasonNote);
}

export function updateOrder(id, fields) {
  return API.updateOrder(id, fields);
}

export function createNewCard(orderId, cardholderId) {
  return API.createNewCard(orderId, cardholderId);
}

export function getCardDetails(cardId) {
  return API.getCardDetails(cardId);
}

export function getTransactionLedger(orderId) {
  return API.getTransactionLedger(orderId);
}

export async function getOrderHistory(
  orderId: string | undefined
): Promise<OrderHistoryRecord[]> {
  if (!orderId) return [];

  return API.getOrderHistory(orderId);
}
